import type { UserGetAgentPostsParams, UserGetProjectPostsParams } from '../api'
import { api } from '../api'

const getProjectPosts = async (data: UserGetProjectPostsParams) => {
  return await api.v1.userGetProjectPosts(data)
}

const getAgentPosts = async (data: UserGetAgentPostsParams) => {
  return await api.v1.userGetAgentPosts(data)
}

export default {
  getProjectPosts,
  getAgentPosts,
}
